import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { loadClientService } from "@/business/files/infrastructure/services/loadClientService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const loadClient = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadClientService.execute(await tokenValidation.execute(), request);
    },
};